import { render, staticRenderFns } from "./BuyTopUp.vue?vue&type=template&id=4838f98f&lang=pug&"
import script from "./BuyTopUp.vue?vue&type=script&lang=ts&"
export * from "./BuyTopUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports